import type { ReactNode } from 'react';

import Breadcrumbs, { type Crumb } from '~/components/BreadCrumbs';

type Props = {
  actions?: ReactNode;
  breadcrumbs: Crumb[];
  children?: ReactNode;
  stackActions?: boolean;
  title: ReactNode;
};

export default function PageHeader({
  actions,
  breadcrumbs,
  children,
  stackActions,
  title
}: Props) {
  return (
    <>
      <div className="content-width flex w-full flex-col gap-1 py-4">
        <div className="hidden md:flex">
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </div>
        <div
          className={`flex flex-col ${children ? 'gap-5' : 'gap-3'} ${
            stackActions ? '' : 'md:flex-row md:items-start md:gap-4'
          }`}
        >
          <div className="flex flex-1 flex-col gap-1">
            <h1 data-cy="page-title" className="text-title-md leading-8">
              {title}
            </h1>
            {children}
          </div>
          {actions}
        </div>
      </div>
      <div className="content-width w-full">
        <hr className="border-grey-divide" />
      </div>
    </>
  );
}
